export default __webpack_public_path__ + "static/media/12.4396ddf4.webp";